module.exports = ".navbar {\r\n    min-height: auto;\r\n}\r\n"